import React from 'react';
import styled from 'styled-components';
import { TEXT_KEY, getText } from 'shared/utils/localization';
import { getProgressBarValues } from 'shared/screens/Events/utils/checkDetailsProgressBar';
import CounterFillBar from './CounterFillBar';

const EntriesCounter = ({ renderElements, item }) => {
  const { totalEntriesAcquired, totalEntriesAvailable } = item;
  const { EntriesCounterDetail, ProgressBarColorTheme } = renderElements;
  const { entriesAmount, showFillingBar, fillPercentage } = getProgressBarValues({
    totalEntriesAcquired,
    totalEntriesAvailable,
  });
  return (
    <EntriesWrapper>
      <EntriesLabelWrapper bgImage={EntriesCounterDetail}>
        <EntriesTitle>{getText(TEXT_KEY.EVENTS_ENTRIES_TITLE)}</EntriesTitle>
        <EntriesProgressBar barTheme={ProgressBarColorTheme}>
          <AmountText>{entriesAmount}</AmountText>
          {showFillingBar && fillPercentage > 0 && (
            <CounterFillBar
              fillPercentage={fillPercentage < 15 ? 15 : fillPercentage}
              barColorTheme={ProgressBarColorTheme}
            />
          )}
        </EntriesProgressBar>
      </EntriesLabelWrapper>
    </EntriesWrapper>
  );
};

export default EntriesCounter;

const EntriesWrapper = styled.div`
  height: 100%;
  width: 70%;
  align-items: center;

  @media only screen and (max-height: 600px) {
    width: 60%;
  }
`;

const EntriesLabelWrapper = styled.div`
  background-image: ${({ bgImage }) => `url(${bgImage})`};
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (max-height: 600px) {
    padding: 0.6rem;
  }
`;

const EntriesTitle = styled.span`
  font-size: 1.2rem;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 0px 0.5px 1px #424242;
  font-weight: 500;

  @media only screen and (max-height: 600px) {
    font-size: 1rem;
  }
`;

const EntriesProgressBar = styled.div`
  position: relative;
  background: ${({ barTheme }) => barTheme.barBackgroundColor};
  border: 1px solid ${({ barTheme }) => barTheme.barBorderColor};
  border-radius: 1.5rem;
  width: 75%;
  padding: 0.1rem;
  margin-bottom: 0.6rem;
`;

const AmountText = styled.span`
  font-size: 1.2rem;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 0px 0.5px 1px #424242;
  font-weight: 600;
  position: relative;
  z-index: 4;

  @media only screen and (max-height: 600px) {
    font-size: 1rem;
  }
  ${({ theme }) => theme.EntriesCounter.AmountText}
`;

